export default __webpack_public_path__ + "static/media/2009.5bdaf1e0.png";